import React from 'react';
import { CaretLeft } from '@phosphor-icons/react/dist/ssr/CaretLeft';
import { BUTTON_TOKENS, BORDER_RADIUS } from '../../../styles/UISystem';

/**
 * IconBack Component
 *
 * Floating back navigation button. Standalone — not built on IconCircleButton.
 * Designed to float over scrolling content, paired with a radial gradient halo.
 * Opaque white with heavier shadow than toolbar buttons.
 *
 * @param {function} onClick - Click handler
 * @param {string} variant - 'circle' (default, opaque white + shadow) or 'plain' (transparent, no shadow)
 * @param {Component} icon - Phosphor icon component (default: CaretLeft). Override to X for dirty/close state.
 * @param {object} style - Additional styles
 */
const IconBack = ({ onClick, variant = 'circle', icon: Icon = CaretLeft, style }) => {
  const isCircle = variant === 'circle';
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '44px',
        height: '44px',
        borderRadius: BORDER_RADIUS.CIRCLE,
        backgroundColor: isCircle ? BUTTON_TOKENS.BACK_BG : 'transparent',
        boxShadow: isCircle ? BUTTON_TOKENS.BACK_SHADOW : 'none',
        cursor: 'pointer',
        ...style,
      }}
    >
      <Icon size={22} color={BUTTON_TOKENS.BACK_ICON} weight="bold" />
    </div>
  );
};

/**
 * IconBackExample Component
 *
 * Used for displaying IconBack example in the UI System
 */
export const IconBackExample = () => {
  return (
    <div>
      <div
        style={{
          fontSize: '24px',
          fontWeight: 'bold',
          marginBottom: '24px',
          textAlign: 'center',
        }}
      >
        IconBack
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '40px',
          backgroundColor: '#F2F2F7',
          padding: '20px',
          borderRadius: '16px',
        }}
      >
        <IconBack />
      </div>
    </div>
  );
};

export default IconBack;
